import { companyInfo } from "@/config/constants";
import { RegisterForm } from "@/modules/authentication/components/register-form";
import { LeftPanel } from "../components/left-panel";
export default function RegisterPage() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      {/* Left Panel - Branding and Benefits */}
      <LeftPanel />

      {/* Right Panel - Register Form */}
      <div className="flex flex-col gap-4 p-6 md:p-10 lg:p-12">
        {/* Mobile Header */}
        <div className="flex justify-center gap-2 lg:hidden mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 border border-gray-300 rounded-lg flex items-center justify-center">
              <img src="/icon.png" alt="logo" className="w-8 h-8" />
            </div>
            <div>
              <img src="/assets/logo_text.png" alt="logo" className="h-8" />
              <p className="text-xs text-gray-500">{companyInfo.description}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
}
